// extracted by mini-css-extract-plugin
export default {"container":"Analytics_container__O-Ri3","menu":"Analytics_menu__B+VKE","scroll":"Analytics_scroll__-oIZh","item":"Analytics_item__QYhTn"};